<template>
  <div>
    <!--当前考季标签+搜索 -->
    <section class="tabSearchBg">
      <div class="Type_left">
        <div class="yearTab" @click="showYear">
          <p>
            {{ currentExamYearInfo.value }}
          </p>
          <img src="https://iqh-zt-pord-cdn.iqihang.com/homeUI/arrowBlack.png" alt="" />
        </div>
      </div>
      <!-- h5顶部 右侧 -->
      <div class="searchIcon">
        <img class="icon" @click="goSearch" src="@/assets/img/loginImg/searchIcon.png" alt="" />
        <span @click="goCourseList">我的课程</span>
        <img class="headImg" :src="userInfo.avatar || userHeader" alt="" @click="personalCenter" />
      </div>
    </section>
    <!-- 专业分类选择 -->
    <template v-if="subNavList.length">
      <div class="topType">
        <van-tabs :active="selected" @click="changeTab" :swipe-threshold="4">
          <van-tab
            v-for="(item, index) in subNavList"
            :key="index"
            :name="index"
            :title="item.name"
          ></van-tab>
        </van-tabs>
        <div class="open-more" @click="showCatalog = !showCatalog">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/homeUI/catalog-more1.png" alt="" />
        </div>
      </div>
    </template>
    <template v-if="showCatalog">
      <div class="catalog-box"  @click="showCatalog = !showCatalog">
        <div class="catalog-list">
          <div
            :class="{ active: selected === index }"
            v-for="(item, index) in subNavList"
            :key="index"
            @click.stop="changeTab(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </template>
    <ChatType v-if="show" @closeAdvisory="closeAdvisory" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { setBaseUrl } from '@/utils/tools';
import userHeader from '@/assets/img/loginImg/userHeader.png';
import { reqNewHotWord } from '@/api/search';
import ChatType from './chatType.vue';

export default {
  components: {
    ChatType,
  },
  props: {
    subNavList: {
      type: Array,
      default: () => [],
    },
    currentExamYearInfo:{
      type:Object,
      default:()=>{}
    }
  },

  data() {
    return {
      selected: 0, // 当前选中的类目
      userHeader,
      value: '',
      showCatalog: false,
      show: false,
      terminal: 3, // 1.PC；2.APP；3.H5；4.小程序
      terrace: 1,
      newList: [], // 新课堂热搜词
      navHeight: 0,
      // defaultName: '24考研',
    };
  },

  computed: {
    ...mapState(['currentYear', 'userInfo']),
  },

  watch: {
    // currentYear(data) {
    //   this.jumpPage(data.code || data.examTypeId);
    //   this.showName(data);
    // },
  },
  created() {
    window.showYear = () => {
      this.$emit('showYearBox');
    };
  },
  mounted() {
    this.showSelectedSubNav();
    this.NewhotSearch();
    // this.showName(this.currentYear);
    // 判断当前app版本号 当前最新版5.0.7
    if (this.$root.$data.isApp) {
      this.$sendToApp('getStatusBarHeight', false);
      window.iosSetStatusBarHeight = (value) => {
        this.navHeight = value;
      };
    }
  },
  destroyed() {},
  methods: {
    showYear() {
      this.showCatalog = false;
      this.$emit('showYearBox');
    },
    // 切换学科
    // eslint-disable-next-line consistent-return
    changeTab(index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 500) return console.log('点击过快');
      }
      const { showType, redirectUrl, courseId } = this.subNavList[index];
      this.setStorageTab(redirectUrl, index);
      if (showType === 5) {
        this.openCourse(courseId);
        return false;
      }
      if (showType === 6) {
        this.openUrl(redirectUrl);
        return false;
      }
      this.selected = index;
      this.lastTime = Date.now();
      this.$emit('sendCatalog', { index });
      this.showCatalog = false;
      // eslint-disable-next-line
      gio('evar.set', 'courseList_evar', this.subNavList[index].name);
      return true;
    },
    openUrl(redirectUrl) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: redirectUrl }, false);
      } else {
        window.open(redirectUrl);
      }
    },
    openCourse(courseId) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(courseId), false);
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId,
          },
        });
      }
    },
    // 我的课堂
    goCourseList() {
      if (!this.$root.$data.isApp) {
        this.$router.push({ path: '/personalCenter/mycourseList' });
      }
    },
    // 进入搜索
    goSearch() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: `${setBaseUrl('')}/ark/search` }, false);
      } else {
        this.$router.push({
          path: '/search',
        });
      }
    },
    personalCenter() {
      this.$router.push({
        path: '/personalCenter/Index',
      });
    },

    appOpenPage(code) {
      this.$sendToApp(
        'setExamSeason',
        { type: code, interestCourseType: code, examType: 2 },
        false,
      );
    },
    toOldHome(code) {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'setExamSeason',
          {
            type: 1,
            interestCourseType: code,
            url: `/newCoures?code=${code}`,
            examType: 1,
          },
          false,
        );
      } else {
        const routeUrl = this.$router.resolve({
          path: '/newCoures',
          query: {
            code,
          },
        });
        window.location.href = routeUrl.route.fullPath;
      }
    },
    closeAdvisory() {
      this.show = false;
    },
    // 新课堂热搜词
    async NewhotSearch() {
      // 判断是否在APP内部
      this.terminal = this.$root.$data.isApp ? 2 : 3;
      const response = await reqNewHotWord(this.terminal, this.terrace);
      if (response.code === 0) {
        this.newList = response.data;
      }
    },
    // 从学姐详情返回需要定位到学长学姐tab
    setStorageTab(redirectUrl, index) {
      if (redirectUrl?.indexOf('majorSenior') > -1) {
        sessionStorage.setItem('homeSelected', index);
      } else {
        sessionStorage.removeItem('homeSelected');
      }
    },
    // 从学姐详情返回需要定位到学长学姐tab
    showSelectedSubNav() {
      const homeSelected = sessionStorage.getItem('homeSelected');
      const show = sessionStorage.getItem('SeniorDetail');
      if (homeSelected && show) {
        this.selected = Number(homeSelected);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabSearchBg {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 74px;
  margin: 0 auto;
  padding: 0 36px 0 34px;
  background: $bgWhite;
}
.Type_left {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 156px;
  height: 60px;
  padding: 0 10px;
  background: $navBgcolor;
  border-radius: 30px;
}
.yearTab {
  position: relative;
  display: flex;
  align-items: center;
  height: 74px;
  p {
    color: $fontColor;
    font-size: 28px;
  }
  img {
    display: block;
    width: 22px;
    height: 14px;
    margin-left: 4px;
  }
}
.search-app {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .search {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 400px;
    height: 60px;
    padding: 0 0 0 40px;
    background: $navBgcolor;
    border-radius: 30px;
    img {
      width: 26px;
      height: 26px;
    }
    span {
      padding-left: 18px;
      color: #787878;
      font-weight: 400;
      font-size: 24px;
    }
  }
  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    margin-left: 30px;
    background: $navBgcolor;
    border-radius: 50%;
  }
  .icon-chat {
    width: 40px;
    height: 38px;
  }
  .searchswiper {
    position: absolute;
    left: 40%;
    width: 44%;
    height: 52px;
    overflow: hidden;
    color: $fontColorBlack;
    font-weight: 400;
    font-size: 24px;
    line-height: 50px;
  }
}
.searchIcon {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .icon {
    width: 36px;
    height: 36px;
  }

  span {
    height: 50px;
    margin-left: 40px;
    color: $fontColor;
    font-weight: 400;
    font-size: 36px;
    line-height: 50px;
  }
  .headImg {
    width: 48px;
    height: 48px;
    margin-left: 40px;
    border-radius: 50%;
  }
}

.topType {
  position: fixed;
  top: 74px;
  left: 0;
  z-index: 20;
  box-sizing: border-box;
  width: 100%;
  height: 94px;
  padding: 0 90px 20px 45px;
  background: #fff;
  background: $bgWhite;
  
  //  ::v-deep .van-tab {
   
  // }
  ::v-deep .van-tab:first-child {
    margin-right: 10px;
    padding: 0;
  }
  ::v-deep .van-tabs__line {
    display: none;
  }
  ::v-deep .van-tab.van-tab--active::before {
    position: absolute;
    right: 50%;
    bottom: -2px;
    left: 50%;
    width: 21px;
    height: 7px;
    background: url('../../../assets/img/loginImg/activeType.png') no-repeat center;
    background-size: 100% 100%;
    border-radius: 6px;
    transform: translate(-50%, -50%);
    content: '';
  }
  ::v-deep .van-tab.van-tab--active .van-tab__text {
    color: #ff6c02;
    font-weight: 500;
    font-size: 20px;
  }
  ::v-deep .van-tabs__nav--complete {
    padding-left: 0;
  }
  ::v-deep .van-tab {
    flex: none;
     justify-content: flex-start;
    .van-tab__text {
      color: #000;
      font-weight: 400;
      font-size: 16px;
    }
  }
}
.open-more {
  position: absolute;
  right: 42px;
  bottom: 24px;
  // background: #fff;
  img {
    width: 56px;
    height: 44px;
  }
}
.catalog-box {
  position: fixed;
  top: 158px;
  left: 0;
  z-index: 2200;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.5);
  .catalog-list {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    width: 750px;
    padding: 42px 0 42px 42px;
    // min-height: 330px;
    background: #fff;
    border-radius: 0 0 16px 16px;
    > div {
      margin: 0 32px 36px 0;
      padding: 11px 40px;
      color: #333;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
      background: #fef0e6;
      border-radius: 23px;
    }
    > div.active {
      color: #fff;
      background: #ff6c02;
    }
  }
}
</style>
